import { defineComponent as _defineComponent } from 'vue'
import UiButton from 'JS/components/UiButton.vue';
import { createPrebuiltHeaderPromoAttributes, createPrebuiltHeaderSubcatPromoAttributes } from '../header-promo-attrs';
import { cssVarsToStyleString } from 'JS/dxp/utilities/css-vars';
import { PrebuiltCategoryHeaderData } from 'JS/dxp/types/widgets/prebuilt-header-widget';


export default /*#__PURE__*/_defineComponent({
  __name: 'PoultrySuppliesHeader',
  props: {
    data: null
  },
  setup(__props: any) {



const title = "Poultry Supplies";
const subtitle = "Find everything you need to raise a healthy flock of poultry – from poultry feed and feeders to heat lamps, coops & more!";

const image = "url('/assets/images/dxp/prebuilt-headers/Poultry-Supplies.jpg')";

const gaDataAttributes = createPrebuiltHeaderPromoAttributes(title, subtitle);


return { __sfc: true,title, subtitle, image, gaDataAttributes, UiButton, createPrebuiltHeaderSubcatPromoAttributes, cssVarsToStyleString }
}

})